// AutoGenerated
export enum EnmSarkiLinkTip {
    "PDF" = 1,
    "Midi Kaydı" = 2,
    "Full Midi Kaydı" = 3,
    "Ses Kaydı" = 4,
    "Konser Videosu" = 5,
    "Başka Koro Videosu" = 6,
    "Eski PDF" = 7,
}